$(document).ready(function() {
$(".nav-mobile ul li.cart").click(function (e) {
  e.preventDefault();
  $("cart-drawer").addClass("active");
});

  
  var navbar = $(".nav-mobile");  // The mobile navbar
  var headerWrapper = $(".header-wrapper");  // The header wrapper

  function checkHeaderVisibility() {
    var headerOffset = headerWrapper.offset().top;
    var headerHeight = headerWrapper.outerHeight();
    var scrollPosition = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scrollPosition + windowHeight >= headerOffset && scrollPosition <= headerOffset + headerHeight) {
      navbar.fadeOut();
        $(".mobile_free_shipping_bar").removeClass("enable_nav_bar");
       $("body").removeClass("body_enable_nav_bar")
     
    } else {
      navbar.fadeIn();
     $(".mobile_free_shipping_bar").addClass("enable_nav_bar");
       $("body").addClass("body_enable_nav_bar")
    }
  }

  $(window).on("scroll", function() {
    checkHeaderVisibility();
  });
  checkHeaderVisibility();
});
